import { StoreGetProductsParams } from '@medusajs/medusa'
import Head from '@modules/common/components/head'
import Layout from '@modules/layout/templates'
import InfiniteProducts from '@modules/products/components/infinite-products'
import RefinementList from '@modules/store/components/refinement-list'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { NextPageWithLayout } from 'types/global'

const Store: NextPageWithLayout = () => {
  const [params, setParams] = useState<StoreGetProductsParams>({})

  const router = useRouter()

  useEffect(() => {
    if (router.query.categoryId) {
      const categoryId = Array.isArray(router.query.categoryId)
        ? router.query.categoryId
        : [router.query.categoryId]
      setParams({
        ...params,
        category_id: categoryId,
      })
    }
  }, [router.query])

  return (
    <>
      <Head title="Store" description="Explore all of our products." />
      <div className="flex flex-col small:flex-row small:items-start py-6">
        <RefinementList refinementList={params} setRefinementList={setParams} />
        <InfiniteProducts params={params} />
      </div>
    </>
  )
}

Store.getLayout = (page) => <Layout>{page}</Layout>

export default Store
